<template>
  <main class="main-wrap">
    <div class="min-s-hight" style="width:100%">
      <section class="r-s-wrap">
        <div class="container devExtremeGridContainer">
          <div class="row ">
            <div class="col-12 col-sm-12 col-md-3 col-lg-4">
              <div class="form-group has-search " style="width:100%;">
                <span class="fa fa-search form-control-feedback"></span>
                <input
                  v-model="searchKeyword"
                  type="text"
                  class="form-control"
                  placeholder="Search by Vendor Name"
                  @keyup.enter="getListOfOrderAnalysis(0)"
                />
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-9 col-lg-8 ">
              <div class="pull-right displayflex mrtop">
                <!-- <input
                v-model="dateFrom"
                class="dateControl btnmaxwidth"
                type="date"
              /> -->

                <!-- <input
                v-model="dateTo"
                class="mr-l20 dateControl btnmaxwidth"
                type="date"
                :min="dateFrom"
              /> -->
                <!-- <button>Search</button> -->
                <datepicker
                  v-if="onoffFirstDatePicker"
                  v-model="dateFrom"
                  :disabled-dates="disabledDatesFrom"
                  :monday-first="true"
                  :typeable="false"
                  class="my-datepicker mr-r20"
                  calendar-class="my-datepicker_calendar"
                  input-class="booking_input input-bl form-control "
                  format="MM/dd/yyyy"
                  placeholder="From date"
                  :use-utc="true"
                ></datepicker>

                <datepicker
                  v-if="onoff"
                  v-model="dateTo"
                  :monday-first="true"
                  :disabled-dates="disabledDates"
                  :typeable="false"
                  class="my-datepicker mr-r20"
                  calendar-class="my-datepicker_calendar"
                  input-class="booking_input input-bl form-control "
                  format="MM/dd/yyyy"
                  placeholder="To date"
                  :use-utc="true"
                ></datepicker>

                <button
                  type="button"
                  class="btn s-red-btn s-red-width bigSearch"
                  @click="getListOfOrderAnalysis(0)"
                >
                  Search
                </button>
                <button
                  type="button"
                  class="btn s-red-btn s-red-width smallSearch"
                  @click="getListOfOrderAnalysis(0)"
                >
                  <span class="fa fa-search form-control-feedback "></span>
                </button>
              </div>
            </div>
          </div>

          <div class="mr-t20 row col-chooser">
            <div style="max-width:100%;">
              <DxDataGrid
                ref="OrderAnalysisRefID"
                :data-source="orderArray"
                :show-borders="true"
                :hover-state-enabled="true"
                :remote-operations="false"
                :allow-column-reordering="true"
                :row-alternation-enabled="false"
                :column-hiding-enabled="false"
                key-expr="OrderId"
                :show-column-lines="true"
                :show-row-lines="true"
                @optionChanged="isLastPage"
              >
                <!-- <DxGroupPanel :visible="true" /> -->
                <DxSearchPanel
                  :visible="false"
                  :highlight-case-sensitive="true"
                />
                <DxGrouping :auto-expand-all="true" />
                <DxPager
                  :allowed-page-sizes="[5, 10, 20]"
                  :show-page-size-selector="true"
                  :show-info="true"
                  :show-navigation-buttons="true"
                />
                <DxPaging :page-size="20" />
                <DxColumnChooser :enabled="true" />

                <DxColumn
                  data-field="OrderId"
                  caption="Order#"
                  cell-template="OrderIdTemplate"
                  :width="130"
                  :allow-sorting="true"
                  :allow-grouping="true"
                  alignment="left"
                />
                <div slot="OrderIdTemplate" slot-scope="{ data }">
                  <h6> {{ data.OrderId }} </h6>
                </div>
                <DxColumn
                  data-field="ProviderName"
                  caption="Vendor Name"
                  cell-template="ProviderNameTemplate"
                  :allow-sorting="true"
                  :width="150"
                  alignment="left"
                />
                <div slot="ProviderNameTemplate" slot-scope="{ data }">
                  <!-- <h6> Email Id </h6> -->
                  <h6>
                    {{ data.ProviderName }}
                  </h6>
                </div>
                <DxColumn
                  data-field="ResidentName"
                  caption="Resident Name"
                  cell-template="ResidentNameTemplate"
                  :allow-sorting="true"
                  :width="150"
                  alignment="left"
                />
                <div slot="ResidentNameTemplate" slot-scope="{ data }">
                  <h6>
                    {{ data.ResidentName }}
                  </h6>
                </div>
                <!-------------------------------------------------------------------->
                <!-- <DxColumn
                  data-field="BuildingId"
                  caption="Vendor stripe payout account ID"
                  cell-template="BuildingIdTemplate"
                  :allow-sorting="true"
                  alignment="center"
                />
                <div slot="BuildingIdTemplate" slot-scope="{ data }">
                  <h6>
                    {{ data.BuildingId }}
                  </h6>
                </div> -->
                <!--------------------------------------------------------------------------->
                <DxColumn
                  data-field="MarginType"
                  caption="Margin Type"
                  cell-template="MarginTypeTemplate"
                  :allow-sorting="true"
                  :width="150"
                  alignment="center"
                  :visible="false"
                />
                <div slot="MarginTypeTemplate" slot-scope="{ data }">
                  <h6>
                    {{
                      data.MarginType == 'Both'
                        ? 'Percentage and Fixed'
                        : data.MarginType
                    }}
                  </h6>
                </div>
                <!--------------------------------------------------------------------------->
                <DxColumn
                  data-field="MarginPercent"
                  caption="Margin Percent"
                  cell-template="MarginPercentTemplate"
                  :allow-sorting="true"
                  :width="150"
                  alignment="center"
                  :visible="false"
                />
                <div slot="MarginPercentTemplate" slot-scope="{ data }">
                  <h6> {{ data.MarginPercent }} %</h6>
                </div>
                <!---------------------------------------------------------------------------->
                <DxColumn
                  data-field="MarginFixed"
                  caption="Margin Fixed ($)"
                  cell-template="MarginFixedTemplate"
                  :allow-sorting="true"
                  :width="150"
                  alignment="center"
                  :visible="false"
                />
                <div slot="MarginFixedTemplate" slot-scope="{ data }">
                  <h6> $ {{ data.MarginFixed }} </h6>
                </div>
                <!---------------------------------------------------------------------------->
                <!---------------------------------------------------------------------------->
                <DxColumn
                  data-field="MarginAmount"
                  caption="Margin Amount($)"
                  cell-template="MarginAmountTemplate"
                  :allow-sorting="true"
                  :width="150"
                  alignment="center"
                  :visible="false"
                />
                <div slot="MarginAmountTemplate" slot-scope="{ data }">
                  <h6> $ {{ data.MarginAmount }} </h6>
                </div>

                <DxColumn
                  data-field="TotalResidentPaidAmount"
                  caption="Total amount paid by Resident($)"
                  cell-template="TotalResidentPaidAmountTemplate"
                  :allow-sorting="false"
                  :width="150"
                  alignment="center"
                />
                <div
                  slot="TotalResidentPaidAmountTemplate"
                  slot-scope="{ data }"
                >
                  <h6> $ {{ data.TotalResidentPaidAmount }} </h6>
                </div>

                <!-- <DxColumn
                  data-field="TotalVendorPaidTillDate"
                  caption="Total amount paid to  Vendor($)"
                  cell-template="TotalVendorPaidTillDateTemplate"
                  :allow-sorting="false"
                  :width="150"
                  alignment="center"
                />
                <div
                  slot="TotalVendorPaidTillDateTemplate"
                  slot-scope="{ data }"
                >
                  <h6>$ {{ data.TotalVendorPaidTillDate }} </h6>
                </div> -->

                <!---------------------------------------------------------------------------->
                <DxColumn
                  data-field="TotalAmountWithBL"
                  caption="Total amount held with BL"
                  cell-template="TotalAmountWithBLTemplate"
                  :allow-sorting="true"
                  :width="150"
                  alignment="center"
                />
                <div slot="TotalAmountWithBLTemplate" slot-scope="{ data }">
                  <h6> $ {{ data.TotalAmountWithBL }} </h6>
                </div>

                <!-- <DxToolbar>
                  <DxItem location="before" template="refreshTemplate" />
                </DxToolbar> -->

                <DxToolbar>
                  <DxToolbarItem name="groupPanel" />
                  <DxToolbarItem location="after" template="button-template" />
                  <DxToolbarItem name="addRowButton" show-text="always" />
                  <DxToolbarItem name="exportButton" />
                  <DxToolbarItem name="columnChooserButton" />
                  <DxToolbarItem name="searchPanel" />
                </DxToolbar>
                <div slot="button-template" slot-scope="{ data }">
                  <DxButton
                    :text="expanded ? 'Collapse All' : 'Expand All'"
                    :width="136"
                    @click="expanded = !expanded"
                  />
                </div>

                <!-- ----------------------------------------------------------------------- -->
                <DxMasterDetail
                  :enabled="true"
                  template="masterDetailTemplate"
                />

                <div slot="masterDetailTemplate" slot-scope="{ data }">
                  <div>
                    <div class="master-detail-caption mb-2">
                      <h6 class="highlighted-text">Progress payment</h6>
                    </div>
                    <DxDataGrid
                      :data-source="
                        data.ProgressPayment ? data.ProgressPayment : []
                      "
                      :show-borders="true"
                      :column-auto-width="true"
                    >
                      <DxColumn
                        data-field="Name"
                        caption="Description"
                        cell-template="descriptionTemplate"
                      />
                      <div slot="descriptionTemplate" slot-scope="{ data }">
                        {{ data.Name }}
                      </div>
                      <DxColumn
                        data-field="Value"
                        caption="Percentage(%)"
                        cell-template="valueTemplate"
                        alignment="center"
                      />
                      <div slot="valueTemplate" slot-scope="{ data }">
                        {{ data.Value }} %
                      </div>
                      <DxColumn
                        data-field="Created"
                        caption="Requested date"
                        cell-template="CreatedTemplate"
                        alignment="center"
                      />
                      <div slot="CreatedTemplate" slot-scope="{ data }">
                        {{ data.Created }}
                      </div>
                      <DxColumn
                        data-field="Paid"
                        caption="Payment date"
                        cell-template="paymentTemplate"
                        alignment="center"
                      />
                      <div slot="paymentTemplate" slot-scope="{ data }">
                        {{ data.Paid }}
                      </div>
                    </DxDataGrid>
                  </div>
                  <br />
                  <div>
                    <div class="master-detail-caption mb-2">
                      <h6 class="highlighted-text">Refund payment</h6>
                    </div>
                    <DxDataGrid
                      :data-source="
                        data.RefundPayment ? data.RefundPayment : []
                      "
                      :show-borders="true"
                      :column-auto-width="true"
                    >
                      <DxColumn
                        data-field="RefundReason"
                        caption="Refund Reason"
                        cell-template="RefundReasonTemplate"
                      />
                      <div slot="RefundReasonTemplate" slot-scope="{ data }">
                        {{ data.RefundReason }}
                      </div>
                      <DxColumn
                        data-field="AmountRefunded"
                        caption="Amount Refunded($)"
                        cell-template="valueTemplate"
                        alignment="center"
                      />
                      <div slot="valueTemplate" slot-scope="{ data }">
                        $ {{ data.AmountRefunded }}
                      </div>
                      <DxColumn
                        data-field="RequestedDate"
                        caption="Requested date"
                        cell-template="CreatedTemplate"
                        alignment="center"
                      />
                      <div slot="CreatedTemplate" slot-scope="{ data }">
                        {{ data.RequestedDate }}
                      </div>
                      <DxColumn
                        data-field="RefundDate"
                        caption="Refund date"
                        cell-template="paymentTemplate"
                        alignment="center"
                      />
                      <div slot="paymentTemplate" slot-scope="{ data }">
                        {{ data.RefundDate }}
                      </div>
                    </DxDataGrid>
                  </div>
                </div>
              </DxDataGrid>
            </div>
          </div>
        </div>
      </section>
      <loader v-if="loading"></loader>
      <refundRequestModal
        v-if="viewRefundRequestFlag"
        @response="viewRefundRequestFlag = false"
      ></refundRequestModal>
    </div>
  </main>
</template>

<script>
import datepicker from 'vuejs-datepicker'

import Layout from '@layouts/main'
import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.compact.css'
import '@/public/css/devExtremeGridCssModified.css'
import { providerMethods } from '@state/helpers'
import viewRefundModal from '@src/payment/admin/viewRefundRequest.vue'
import refundRequestModal from '@src/payment/order/vendorRefundRequestPopup.vue'
import loader from '@views/loader'
import moment from 'moment'
import {
  DxDataGrid,
  DxColumn,
  DxPager,
  DxPaging,
  DxGrouping,
  DxGroupPanel,
  DxSearchPanel,
  DxMasterDetail,
  DxColumnChooser,
  DxToolbarItem,
} from 'devextreme-vue/data-grid'
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar'
import { DxButton } from 'devextreme-vue/button'
import appConfig from '@src/app.config'
import dxButton from 'devextreme/ui/button'
export default {
  page: {
    title: 'My Orders',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout: Layout,
    DxDataGrid,
    DxColumn,
    DxPager,
    DxPaging,
    DxSearchPanel,
    DxGrouping,
    DxGroupPanel,
    DxMasterDetail,
    DxColumnChooser,
    DxItem,
    DxToolbar,
    DxToolbarItem,
    DxButton,
    loader,
    refundRequestModal,
    datepicker,
  },
  data() {
    return {
      totalCount: 0,
      expanded: true,
      orderSearch: '',
      InquiryStatusdata: ['Pending', 'Declined', 'Fulfilled'],
      superAdminServiceArray: [],
      orderArray: [],
      loading: false,
      searchKeyword: '',
      viewRefundRequestFlag: false,
      dateFrom: null,
      dateTo: null,
      disabledDates: {
        to: new Date(this.startDate),
      },
      disabledDatesFrom: {
        from: new Date(this.endDate),
      },
      onoff: true,
      onoffFirstDatePicker: true,
    }
  },

  watch: {
    searchKeyword: {
      handler: function(val, oldVal) {
        if (!val) {
          this.orderArray = []
          this.getListOfOrderAnalysis(0)
        }
      },
      deep: true,
    },
  },
  created() {
    var date = new Date()
    var lastDay = new Date(date.getUTCFullYear(), date.getUTCMonth(), 1)
    this.dateTo = moment(String(lastDay)).format('MM/DD/YYYY')

    var firstDay = new Date(date.getUTCFullYear(), 0, 2)
    this.dateFrom = moment(String(firstDay)).format('MM/DD/YYYY')

    this.getListOfOrderAnalysis(0)
  },

  methods: {
    ...providerMethods,
    refreshDataGrid() {
      //this.$refs[this.orderArray].instance.refresh();
    },
    collapseAllClick() {
      this.expanded = !this.expanded
    },
    // FETCH ORDER FROM BUILDING LINK API
    // Function to fetch all inquires
    async getListOfOrderAnalysis(recordAvailable, isNext) {
      try {
        this.loading = true

        const responseBLK = await this.OrderAnalysisReportAsync({
          recordAvailable: recordAvailable,
          searchKeyword: this.searchKeyword.length ? this.searchKeyword : '%00',
        })
        this.loading = false
        console.log(responseBLK)
        if (isNext) {
          this.orderArray = this.orderArray.concat(responseBLK)
        } else {
          this.orderArray = responseBLK
        }

        this.orderArray.forEach((element) => {
          element.ProgressPayment = [
            {
              Name: 'At start of work',
              Value: 100,
              Created: 'Yesterday',
              Paid: 'Today',
            },
          ]

          element.RefundPayment = [
            {
              RefundReason: 'Window damaged',
              AmountRefunded: 100,
              RequestedDate: 'Yesterday',
              RefundDate: 'Today',
            },
          ]
        })

        // this.orderArray = [
        //   {
        //     OrderId: 66984,
        //     OrderCreatedDate: '2022-05-27',
        //     ProviderName: 'Best Buy',
        //     ResidentName: 'Best Buy',
        //     BuildingId: 'acct_1L2nq02R0GkvUzL1',
        //     ServiceName: '',
        //     ServiceDescription: '',
        //     MarginType: 'Both',
        //     MarginPercent: 10,
        //     MarginFixed: 2,
        //     MarginAmount: 12,
        //     TotalCost: 100,
        //     TotalResidentPaidAmount: 100,
        //     TotalVendorPaidTillDate: 88,
        //     PayoutReference: '',
        //     TotalAmountWithBL: 12,
        //   },
        // ]

        // let keywordFilter = this.searchKeyword
        // this.orderArray = this.orderArray.filter((obj) => {
        //   return obj.vendorName
        //     .toLowerCase()
        //     .includes(keywordFilter.toLowerCase())
        // })
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    // ----------------------------------------------------------------------------
    // Pagination

    isLastPage(pagination) {
      var currentPage = pagination.value + 1
      var TotalPage = this.$refs['OrderAnalysisRefID'].instance.pageCount()
      var pageIndex = this.$refs['OrderAnalysisRefID'].instance.pageIndex() + 1
      if (
        pageIndex === currentPage &&
        currentPage === TotalPage &&
        this.orderArray.length > 99
      ) {
        //   console.log('Pagination started working')
        this.getListOfOrderAnalysis(this.orderArray.length, 1)
      } else if (pagination.fullName === 'paging.pageSize') {
        if (
          typeof pagination.previousValue === 'number' &&
          typeof pagination.value === 'number' &&
          pagination.value > pagination.previousValue &&
          this.orderArray.length > 99
        ) {
          // console.log('Pagination due to page size increment')
          this.getListOfOrderAnalysis(this.orderArray.length, 1)
        }
      }
    },
    // ----------------------------------------------------------------------------
    viewInquiryMessage(data) {
      this.$router.push({
        name: 'adminviewmilestone',
        query: {
          vendorName: data.vendorName,
          serviceRequestForm: data.serviceRequestForm,
          serviceRequestId: data.serviceRequestId,
          serviceCost: data.serviceCost ? data.serviceCost : 100,
        },
      })
    },
    // -----------------------------------------------------------------------------
    openAdminRefundRequestModal() {
      this.viewRefundRequestFlag = true
    },
  },
}
</script>

<style scoped>
.dateControl {
  padding: 4px;
  border: 1px solid #ced4da;
  border-radius: 4px;
}

/* .dx-toolbar-label {
  display: none;
} */

.dx-toolbar-label {
  content: 'Add Or remove Column';
}

.dx-popup-content {
  margin-top: 5px;
  height: 180px !important;
}

.dx-popup-content::after {
  content: 'Drag a column from or to the box to add or remove it';
  color: #d13851;
}
</style>
